export enum NotificationType {
	Default = 'default',
	Job = 'job',
	Counter = 'counter',
}

export enum NotificationStyle {
	Info = 'info',
	Success = 'success',
	Error = 'error',
	Progress = 'progress',
	Counter = 'counter',
}

export enum ProgressIcon {
	Job = 'job',
	Passenger = 'passenger',
	WashCar = 'wash_car',
	BusStation = 'bus_station',
	Box = 'box',
	PizzaBox = 'pizza_box',
}
